import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  timeout: 90000,
  headers: { "Content-Type": "application/json" },
});

export async function generateAlign(payload) {
  const { data } = await client.post("/awake/align", payload);
  return data;
}

export async function sendKata(payload) {
  const { data } = await client.post("/awake/kata", payload);
  return data;
}

export async function generateEvolve(payload) {
  const { data } = await client.post("/awake/evolve", payload);
  return data;
}
